(function () {
  const ROOT_SELECTOR = '.aeya-faq';
  const ITEM_SELECTOR = '[data-faq-item]';
  const TOGGLE_SELECTOR = '[data-faq-toggle]';
  const BODY_SELECTOR = '[data-faq-body]';
  const INIT_FLAG = 'aeyaFaqInited';

  function setOpen(item, open) {
    const body = item.querySelector(BODY_SELECTOR);
    const toggle = item.querySelector(TOGGLE_SELECTOR);
    if (!body) return;

    if (open) {
      item.dataset.open = 'true';
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      body.style.maxHeight = body.scrollHeight + 'px';
    } else {
      if (item.dataset.open === 'true') {
        body.style.maxHeight = body.scrollHeight + 'px';
        body.offsetHeight;
      }
      item.dataset.open = 'false';
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      body.style.maxHeight = '0px';
    }
  }

  function init(root) {
    if (!root || root.dataset[INIT_FLAG] === 'true') return;
    root.dataset[INIT_FLAG] = 'true';
    const items = Array.from(root.querySelectorAll(ITEM_SELECTOR));

    items.forEach(function (item) {
      const body = item.querySelector(BODY_SELECTOR);
      const toggle = item.querySelector(TOGGLE_SELECTOR);
      if (!body || !toggle) return;

      body.style.maxHeight = item.dataset.open === 'true' ? body.scrollHeight + 'px' : '0px';

      toggle.addEventListener('click', function () {
        const isOpen = item.dataset.open === 'true';
        items.forEach(function (other) {
          if (other !== item) setOpen(other, false);
        });
        setOpen(item, !isOpen);
      });
    });

    window.addEventListener('resize', function () {
      items.forEach(function (item) {
        const body = item.querySelector(BODY_SELECTOR);
        if (body && item.dataset.open === 'true') {
          body.style.transition = 'none';
          body.style.maxHeight = 'none';
          const h = body.scrollHeight;
          body.style.maxHeight = h + 'px';
          body.offsetHeight;
          body.style.transition = '';
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    const root = e.target.querySelector(ROOT_SELECTOR);
    if (root) init(root);
  });
})();
